export type CategoryFilter = {
	// WooCommerce
	slugs: string[];
	ids: number[];
	// Magento GraphQL
	magentoUrlPaths: string[];
	magentoUids: string[];
	// Shopify
	shopifyCollections: string[];
	// Best-effort brand extraction hints (used by Magento)
	brandHints: string[];
};

export type StoreConfig = {
	stack?: string;
	note?: string;
	tosAcked?: boolean;
	tosAckedAt?: number;
	brandHints?: string[];
	categoryFilter?: Partial<CategoryFilter>;
	/**
	 * PrestaShop only: the `{id}-{slug}` category to page when the operator has
	 * picked none in the settings UI. Point it at a shop's root catalog
	 * category to sweep everything in one pass; left unset, the adapter pages
	 * every category the sitemap lists and de-duplicates the overlap.
	 */
	prestashopRootCategory?: string;
	/**
	 * Geta Commerce Cloud / Omnium only. The storefront and the commerce API sit
	 * on different hosts, so the API origin is configured alongside the base
	 * URL; left unset it is derived from the storefront (www.sprell.no ->
	 * api.sprell-no.getadigital.cloud). `omniumMarketId` scopes the catalog —
	 * without it the listing mixes in the tenant's B2B markets and deep pages
	 * start failing — and `omniumWebWarehouse` names the warehouse whose stock
	 * is the online stock (500 for Sprell: the sales-channel entity 400 carries
	 * allocations, not stock, and reads as sold out).
	 */
	omniumApiUrl?: string;
	omniumMarketId?: string;
	omniumWebWarehouse?: string;
	sweepIntervalMs?: number;
	concurrency?: number;
	requestTimeoutMs?: number;
	baseIntervalMs?: number;
};

export const SWEEP_INTERVAL_MIN_MS = 30_000;
export const CONCURRENCY_MIN = 1;
export const CONCURRENCY_MAX = 8;
export const REQUEST_TIMEOUT_MIN_MS = 1_000;
export const REQUEST_TIMEOUT_MAX_MS = 60_000;
